import { render, staticRenderFns } from "./VendorDataFlowTab.vue?vue&type=template&id=119e8e10&"
import script from "./VendorDataFlowTab.vue?vue&type=script&lang=js&"
export * from "./VendorDataFlowTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports